import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** 従業員設定の入口 */
export default function Settings() {
  const { t } = useTranslation();
  return (
    <div className="page settings-page">
      <h1>{t('employee.settings')}</h1>
      <p className="settings-intro">{t('settings.intro')}</p>

      <div className="settings-grid">
        <Link to="/dashboard/settings/consent" className="settings-card-link">
          <h3>{t('settings.consentTitle')}</h3>
          <p className="settings-card-desc">{t('settings.consentDesc')}</p>
        </Link>
        <Link to="/dashboard/settings/notifications" className="settings-card-link">
          <h3>{t('settings.notificationsTitle')}</h3>
          <p className="settings-card-desc">{t('settings.notificationsDesc')}</p>
        </Link>
        <Link to="/dashboard/settings/deletion" className="settings-card-link">
          <h3>{t('settings.deletionTitle')}</h3>
          <p className="settings-card-desc">{t('settings.deletionDesc')}</p>
        </Link>
      </div>

      <p className="settings-back">
        <Link to="/dashboard">{t('common.back')} → {t('settings.backToDashboard')}</Link>
      </p>
    </div>
  );
}
